import moment from 'moment';
import { RcaConstants } from './Rca.constants';

const lastSevenDays = [moment().subtract(7, 'd'), moment().subtract(1, 'd') ];
let diff = moment(lastSevenDays[1]).diff(moment(lastSevenDays[0]), 'days');

const initialState = {
  dateRange: lastSevenDays,
  compareDateRange: [
    moment(lastSevenDays[0]).subtract(diff + 1, 'd'),
    moment(lastSevenDays[1]).subtract(diff + 1, 'd')
  ],
  isExtendedDataAvailable: true,
  extremeLeftNodeId: ''
};

const RcaReducer = (state = initialState, action) => {
  switch (action.type) {
    case RcaConstants.GET_RCA_REQUEST:
      return {
        ...state,
        RcaList: {
          loading: true,
          error: false,
          ...action.payload
        }
      };

    case RcaConstants.GET_RCA_SUCCESS:
      return {
        ...state,
        RcaList: {
          loading: false,
          error: false,
          ...action.payload
        }
      };

    case RcaConstants.GET_RCA_ERROR:
      return {
        ...state,
        RcaList: {
          loading: false,
          error: true
        }
      };

    case RcaConstants.GET_LATEST_REPORT_DATE_REQUEST:
      return {
        ...state,
        latestReportDate: {
          loading: true,
          error: false,
          ...action.payload
        }
      };

    case RcaConstants.GET_LATEST_REPORT_DATE_SUCCESS:
      return {
        ...state,
        latestReportDate: {
          loading: false,
          error: false,
          ...action.payload
        }
      };

    case RcaConstants.GET_LATEST_REPORT_DATE_ERROR:
      return {
        ...state,
        latestReportDate: {
          loading: false,
          error: true
        }
      };

    case RcaConstants.UPDATE_FILTER:
      return {
        ...state,
        ...action.payload
      };

    case RcaConstants.UPDATE_RCA_LIST:
      return {
        ...state,
        RcaData: action.payload
      };

    case RcaConstants.UPDATE_IS_EXTENDED_DATA_AVIALBLE:
      return {
        ...state,
        isExtendedDataAvailable: action.payload
      };

    case RcaConstants.UPDATE_EXTREME_LEFT_NODE:
      return {
        ...state,
        extremeLeftNodeId: action.payload
      }

    default:
      return state;
  }
};

export default RcaReducer;
